import React from 'react'
import { Route } from 'react-router-dom'
import { UserInspector } from 'pobble-components/dist/pobble-user'
import SchoolNav from './school-nav/school-nav'
import SchoolProfile from './school-profile/school-profile.container'
import SchoolTeam from './school-team/school-team.container'
import SchoolData from './school-data/school-data.container'
import SchoolAdd from './school-add/school-add'

const School = ({ classes, me }) => {
  return (
    <UserInspector haveRights={me => me.account.policy.view_school_tab}>
      <SchoolNav />
      <Route exact path="/school/edit" component={SchoolProfile} />
      <Route exact path={['/school', '/school/team']} component={SchoolTeam} />
      <Route exact path="/school/data" component={SchoolData} />
      <Route exact path="/school/add-pupils" component={SchoolAdd} />
    </UserInspector>
  )
}

export default School
